import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { GlobalService } from 'src/app/shared/global.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/shared/services/util.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { VehiculoFuncionarioModel } from 'src/app/models/vehiculoFuncionario.model';
import { AdministrarFuncionarioDTO, VehiculoFuncionario } from 'src/app/models/administrarFuncionario.model';
import { NgbModal, ModalDismissReasons  } from '@ng-bootstrap/ng-bootstrap';
import { ModalRegistrarVehiculoComponent } from './modal-registrar-vehiculo.component';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { Subscription } from 'rxjs';
import { DominiosService } from 'src/app/shared/services/dominios.service';

@Component({
    selector: 'app-registrar-vehiculos-component',
    templateUrl: './registrar-vehiculos.component.html',
    styleUrls: ['../administrar-funcionarios.component.scss']
})
export class RegistrarVehiculoComponent implements OnInit {

    @Input() datosFuncionario: AdministrarFuncionarioDTO;
    @Input() existeFuncionario: boolean;
    @Input() vehiculos: VehiculoFuncionario[];
    @Output() vehiculosChange: EventEmitter<any> = new EventEmitter();
    @Input() isSGA: boolean;
    public rolUsuario: string;
    public capturaHuella: boolean;
    public listaFiltro: VehiculoFuncionarioModel[] = [];
    public listaEliminar: VehiculoFuncionarioModel[] = [];
    public htmlSticker: string;
    public modalOptionsEliminar: ConfirmationModalOptions;
    public isTH: boolean;


    constructor(
        private router: Router,
        private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private alertService: AlertService,
        private global: GlobalService,
        private utilService: UtilService,
        public route: ActivatedRoute,
        public modalService: NgbModal) {
        this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);
    }

    ngOnInit() {
        // if (this.existeFuncionario) {
        //     this.consultarVehiculos();
        // }
        if( this.rolUsuario === DominiosService.ROL_ADMINISTRADOR_TH )
            this.isTH=true;

        this.modalOptionsEliminar = new ConfirmationModalOptions(
            'Confirmación',
            ConstantesService.MENSAJE_CONFIRMACION_ELIMINAR_VEHICULO,
            'SI', 'NO', 'fas fa-times', false, !this.isSGA, 'Eliminar Vehiculo', null, 'btn-primary');
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

    /**
     * @author klagos@asesoftware.com
     * Método que llama al servicio para realizar la consulta de vehiculos
     */
    consultarVehiculos() {
        this.spinner.show();
        const serviceProvider = 'consultarVehiculos';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push([
            'filterBy',
            this.urlService.encodeURI('tipoIdFuncionario=' + this.datosFuncionario.tipoDocumento
                + '&' + 'numeroIdFuncionario=' + this.datosFuncionario.numDocumento)]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null,
            queryParams), this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.vehiculos = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible Cargar los vehiculos');
            }
        );
    }

    /**
     * Método que permite abrir el modal de solicitar ajuste y capturar la respuesta que se obtenga al cerrar el mismo
     * @function abrirModaAjuste
     * @author dfranco@asesoftware.com
     */
    public abrirModal() {
        const modalRef = this.modalService.open(
            ModalRegistrarVehiculoComponent, { centered: true, size: 'lg' });
        modalRef.result.then((result) => {
            if (result) {
                this.adicionarVehiculo(result);
            }
        }, (reason) => {
            if (reason === ModalDismissReasons.ESC ||
                reason === ModalDismissReasons.BACKDROP_CLICK) { }
        });
    }

    adicionarVehiculo(result) {
        result.estado = 'ACT';
        const orden = this.vehiculos.length + 1;
        result.ordenVehiculo = orden.toString();
        result.tipoIdFuncionario = this.datosFuncionario.tipoDocumento;
        result.numeroIdFuncionario = this.datosFuncionario.numDocumento;
        this.vehiculos.push(result);

        this.vehiculosChange.emit(this.vehiculos);
    }

    eliminarVehiculo(vehiculoEliminado: VehiculoFuncionario) {
        vehiculoEliminado.estado = DominiosService.ESTADO_VEHICULO_INACTIVO;
        this.vehiculosChange.emit(this.vehiculos);
    }

    validacion(): boolean {
        this.listaFiltro = this.vehiculos.filter(vehiculo => vehiculo.estado
            === 'ACT');
        this.vehiculosChange.emit(this.vehiculos);
        if (this.listaFiltro.length >= 3) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Método que realiza la impresión de la plantilla
     * @author klagos
     */
    generarSticker() {
        if( this.validarCodigoGenerar()) {
        const nombreCompleto = this.datosFuncionario.nombres + ' ' +
        this.datosFuncionario.apellidos;

        this.spinner.show();
        const serviceProvider = 'generarStickerBicicleta';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['nombreFuncionario', nombreCompleto],
            ['numFuncionario', this.datosFuncionario.numDocumento],
            ['tipoIdFuncionario', this.datosFuncionario.tipoDocumento]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null,
            queryParams), this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {

                ConstantesService.descargarDocumento('application/pdf', data.nombre, data.archivo);
                this.spinner.hide();
            }, err => {
                this.utilService.cathException(err, this.alertService , this.spinner);
            }
        );
        }
    }

    private validarCodigoGenerar(): boolean {
        const numbers = /^[0-9]+$/;
        if ( !this.datosFuncionario.numDocumento.match(numbers)) {
            this.utilService.cathException('No es posible generar sticker para el número de documento del funcionario.', this.alertService);
            return false;
        }
        if (this.datosFuncionario.numDocumento.length > 10) {
            this.utilService.cathException
                ('No es posible generar sticker el número de documento excede el tamaño permitido', this.alertService);      
            return false;
        }

        return true;


    }

    /**
     * Método que recibe el evento de confirmación de edición de elementos y ejecuta la actualización
     * @function getConfirmationEditar
     * @param event Objeto que contiene la respuesta del usuario (Si o No)
     * @param generarPDF Bandera que indica si se requiere generar un PDF o no
     */
    public getConfirmationEliminar(event, vehiculo) {

        if (event[0]) {
            this.eliminarVehiculo(vehiculo);
        }
    }

    validarAutorizacion() {
        this.vehiculosChange.emit(this.datosFuncionario);
    }
}
